<template lang="pug">
div
  AppScrollableTable(:has-fixed-column="false")
    AppTable(
      :table-data="tasks"
      :selectable="false"
      hoverable
      :loading="loading"
    )
      template(#empty)
        h4.tasks-empty.text-muted.text-left
          | No tasks

      AppTableColumn(
        v-slot="{ row }"
        :header="taskLabel"
      )
        .task-completed(v-if="isComplete(row)")
          | {{ row.summary }}
        .task-in-progress(v-else)
          template(v-if="row.can_manage && row.can_update")
            a.blank-link(href="#")
              | {{ row.summary }}
          span(v-else)
            | {{ row.summary }}

      AppTableColumn(
        v-slot="{ row }"
        :header="memberLabel"
      )
        TasksListAssignees(
          :task="row"
          :organization="organization"
        )

      AppTableColumn(
        v-slot="{ row }"
        header="Last update"
      )
        | {{ formatTimestamp(row.updated_at) }}

      AppTableColumn.actions(
        v-slot="{ row }"
        header=""
      )
        TasksListActions(
          v-if="row.project.can_manage_tasks"
          :task="row"
        )

  AppPagination(
    v-if="showPagination"
    :pagination="pagination"
    :resource="{ one: 'task', many: 'tasks' }"
    @page-changed="onPageChanged"
  )
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { lowerCase } from 'lodash-es';
import { formatDatetime } from '~/utils/time_utils';

export default {
  name: 'TasksList',
  computed: {
    ...mapState(['loading', 'project', 'pagination', 'organization']),
    ...mapGetters(['tasks', 'isNativeProject']),
    hasTasks() {
      return this.tasks && this.tasks.length;
    },
    taskLabel() {
      return this.isNativeProject ? 'To-do' : 'Task';
    },
    taskLabelPluralized() {
      return `${this.taskLabel}s`;
    },
    memberLabel() {
      return this.isNativeProject ? 'Assignee' : 'Member';
    },
    showPagination() {
      return this.pagination && this.hasTasks;
    },
  },
  methods: {
    ...mapActions(['setFilter']),
    isComplete(task) {
      return lowerCase(task.status) === 'completed';
    },
    formatTimestamp(date) {
      return formatDatetime(moment(date));
    },
    onPageChanged(page) {
      this.setFilter({ page });
    },
  },
};
</script>
